import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { BereichsService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [BereichsService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class BereichsServiceModule {}
